import { render } from "./PartnerMemoEditModal.vue?vue&type=template&id=23c299de&scoped=true&ts=true"
import script from "./PartnerMemoEditModal.vue?vue&type=script&lang=ts"
export * from "./PartnerMemoEditModal.vue?vue&type=script&lang=ts"

import "./PartnerMemoEditModal.vue?vue&type=style&index=0&id=23c299de&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c299de"]])

export default __exports__